module.exports = __webpack_public_path__ + "544ddfa8228268278701b034a37cf77f.pdf";